import { monitorExecutionStatus } from './monitorExecutionStatus';
import { requestUserInputTool } from './requestUserInput';
import { PERSONA_TOOL_NAMES } from './personaTools';

export { createPersonaTools, PERSONA_TOOL_NAMES, type GraphQLClient } from './personaTools';

export const AllClientSideTools = [
  monitorExecutionStatus,
  requestUserInputTool,
];

export const CLIENT_TOOL_NAMES = new Set([
  ...AllClientSideTools.map(tool => tool.name),
  ...PERSONA_TOOL_NAMES,
]);

/**
 * Check if a tool name corresponds to a client-side tool.
 * Client tools run in the browser and handle their own UI,
 * so they should not show approval dialogs.
 */
export function isClientTool(toolName: string | null | undefined): boolean {
  return toolName ? CLIENT_TOOL_NAMES.has(toolName) : false;
}
